import React from 'react';
import imgPortada from "../assets/portada.webp"

const HHTHeader = () => {
  return (
    <header className="relative bg-purple-900 text-white">
      <div className="container mx-auto px-6 py-24 flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 mb-12 md:mb-0">
          <div className="mb-8">
            {/* Logo placeholder - reemplazar con SVG real */}
            {/* <div className="w-48 h-16 bg-white bg-opacity-20 rounded-lg"></div> */}
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
            Tu socio estratégico para encontrar el talento que transforma organizaciones.
          </h1>
          <p className="text-xl text-purple-200 mb-8">
            Conectamos personas con propósito y empresas con visión.
          </p>
          <a href='https://wa.me/5215625464923?text=Hola%2C%20me%20interesa%20contactar%20a%20Hiring%20Human%20Talent.
' target='_blank'>
            <button className="bg-white text-purple-900 px-8 py-3 rounded-lg font-semibold hover:bg-purple-100 transition-colors flex items-center">
              Contáctanos
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </button>
          </a>
        </div>
        <div className="md:w-1/2">
          {/* Imagen placeholder - reemplazar con imagen real */}
          {/* <div className="bg-white bg-opacity-20 rounded-xl h-96 w-full"></div> */}
          <img src={imgPortada} alt='Portada' className='bg-white object-cover bg-opacity-20 rounded-xl h-96 w-full' />
        </div>
      </div>
    </header>
  );
};

export default HHTHeader;